import React, { useState } from 'react';
import { Card, CardBody, CardTitle, Col, Collapse, Container, Row } from 'reactstrap';
import Breadcrumb from 'Components/Common/Breadcrumb';
import MainMap from 'Components/MainMap/Index';
import { Link } from 'react-router-dom';
import voyager from '../../../assets/images/map/voyager.png';
import google from '../../../assets/images/map/google.jpg';
import topo from '../../../assets/images/map/topo.jpg';
import openstreet from '../../../assets/images/map/openstreet.jpg';
import layerSvg from '../../../assets/images/svg/layer.svg'
import protectionZoneSvg from '../../../assets/images/svg/protectionZone.svg'

const SwNormalZoneIndex = () => {

  const [baseMap, setBaseMap] = useState("voyager")
  const [specialZoneBoolean, setSpecialZoneBoolean] = useState(false);
  const [normalZoneBoolean, setNormalZoneBoolean] = useState(false);
  
  const [col1, setcol1] = useState(true);

  const t_col1 = () => {
    setcol1(!col1);
  };

  const protectionZoneFilter = {
    colQuery: `type IN (${normalZoneBoolean === true ? '0': ''},${specialZoneBoolean === true ? '1': ''})`,
    specialZoneBoolean: specialZoneBoolean,
    normalZoneBoolean: normalZoneBoolean,
  }

  // console.log(protectionZoneFilter);
  

  document.title = "Энгийн болон онцгой хамгаалалтын бүс";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Гадаргын ус" breadcrumbItem="Энгийн болон онцгой хамгаалалтын бүс" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody className="border-bottom">
                  <Card className='mainMap_filter'>
                    <CardBody>
                      <CardTitle className='mb-3'> <img width={30} className='me-2' src={layerSvg} alt="" /> Давхаргын мэдээлэл</CardTitle>

                      <ul className="list-unstyled categories-list mb-0">
                        <li>
                          <div className="custom-accordion">
                            <Link className="text-body fw-medium py-1 d-flex align-items-center fw-semibold mb-2" onClick={t_col1} to="#">
                              <i className='me-2'> <img src={protectionZoneSvg} width={20} alt="" /> </i>{" "}
                              {/* <i className="mdi mdi-folder font-size-16 text-warning me-2"></i>{" "} */}
                              Хамгаалалтын бүс{" "}
                              <i
                                className={
                                  col1
                                    ? "mdi mdi-chevron-up accor-down-icon ms-auto"
                                    : "mdi mdi-chevron-down accor-down-icon ms-auto"
                                }
                              />
                            </Link>
                            <Collapse isOpen={col1}>
                              <div className="card border-0 shadow-none ps-2 mb-0">
                                <ul className="list-unstyled mb-0">
                                  <li>
                                    <div className="form-check form-check-primary mb-3 ">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="customCheckcolor2"
                                        checked={specialZoneBoolean}
                                        onChange={() => {
                                          setSpecialZoneBoolean(!specialZoneBoolean)
                                        }}
                                      />
                                      <label
                                        className="form-check-label fw-semibold"
                                        htmlFor="customCheckcolor2"
                                      >
                                        Тусгай
                                      </label>
                                    </div>
                                  </li>
                                  <li>
                                    <div className="form-check form-check-warning mb-3">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="customCheckcolor3"
                                        checked={normalZoneBoolean}
                                        onChange={() => {
                                          setNormalZoneBoolean(!normalZoneBoolean)
                                        }}
                                      />
                                      <label
                                        className="form-check-label fw-semibold"
                                        htmlFor="customCheckcolor3"
                                      >
                                        Энгийн
                                      </label>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </Collapse>
                          </div>
                        </li>
 

                      </ul>
                    </CardBody>
                  </Card>

                  <div className='mapTypeSelection'>
                    <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('voyager') }} src={voyager} alt="" />
                    <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('google') }} src={google} alt="" />
                    <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('topo') }} src={topo} alt="" />
                    <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('openstreet') }} src={openstreet} alt="" />
                  </div>

                  <MainMap baseMap={baseMap} protectionZoneFilter={protectionZoneFilter}  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment >
  );
}

export default SwNormalZoneIndex;